import React from 'react';
import { graphql } from 'gatsby';
import { Container, Row, Col } from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import parse from 'html-react-parser';
import SEO from '../components/seo';
import categoryImg from '../images/contact-us.png';
import circle from '../images/circle.svg';
import purpleBubble from '../images/purple-circle.svg';
import greenBubble from '../images/green-bubble.svg';
import '../styles/post.scss';

const Page = (props) => (
  <>
    <SEO
      title={props.data.markdownRemark.frontmatter.title}
      image={categoryImg}
    />
    <Container fluid className="section-page-banner">
      <Container>
        <Row>
          <Col md="6" sm="12">
            <h1 className="page-header">
              {props.data.markdownRemark.frontmatter.title}
            </h1>
          </Col>
          <Col md="6" sm="12">
            <Parallax className="circle wow" y={[20, -100]} tagOuter="figure">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </Parallax>
            <Parallax
              className="purple-dot wow"
              y={[20, -200]}
              tagOuter="figure"
            >
              <img src={purpleBubble} alt="charli-ai" />
            </Parallax>
          </Col>
        </Row>
      </Container>
    </Container>

    <Container fluid className="section-page-content">
      <Parallax className="green-bubble wow" y={[20, -100]} tagOuter="figure">
        <img src={greenBubble} data-wow-delay="0.5s" alt="charli-ai" />
      </Parallax>
      <Container>
        <Row>
          <Col md="12">
            <div>{parse(props.data.markdownRemark.html)}</div>
          </Col>
        </Row>

        {props.data.markdownRemark.frontmatter.downloadLink ? (
          <Row>
            <Col md="12" className="cta-section">
              <div className="button-orange">
                <a
                  href={props.data.markdownRemark.frontmatter.downloadLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Download {props.data.markdownRemark.frontmatter.title}
                </a>
              </div>
            </Col>
          </Row>
        ) : (
          ''
        )}
      </Container>
    </Container>
  </>
);

export default Page;
export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date
        downloadLink
      }
      html
    }
  }
`;
